import React from "react";
import { Link } from "react-router-dom";

const Offerlayout = () => {
  return (
    <div className="offer--layout">
      <div className="container">
        <div
          className="offer-block"
          style={{
            backgroundImage: "url(/assets/img/bg/offer-bg-4.jpg)",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div className="row align-items-center">
            <div className="col-lg-8 mb-30">
              <div className="white-title">
                <span className="sec-subtitle">Exclusive Offer for You</span>
                <h2 className="sec-title mb-0">
                  Experience Luxury Living in Dubai at Unbeatable Prices
                </h2>
              </div>
            </div>
            <div className="col-lg-4 text-md-end text-center mb-30">
              <Link to="/contact" className="vs-btn style5">
                Learn More & Book Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Offerlayout;
